type SourceTitleFields = {
  title?: unknown;
  documentTitle?: unknown;
  document_title?: unknown;
  fileName?: unknown;
  filename?: unknown;
  file_name?: unknown;
};

const cleanText = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const looksLikeFilename = (value: string | undefined): boolean =>
  Boolean(value && /(^|[/\\])[^/\\]+\.[A-Za-z0-9]{1,10}$/.test(value));

export function getSourceFileName(source: SourceTitleFields): string | undefined {
  return (
    cleanText(source.fileName) ||
    cleanText(source.filename) ||
    cleanText(source.file_name) ||
    (looksLikeFilename(cleanText(source.title)) ? cleanText(source.title) : undefined)
  );
}

export function getSourceDocumentTitle(
  source: SourceTitleFields,
  fallback = 'Untitled Document',
): string {
  const explicitTitle = cleanText(source.documentTitle) || cleanText(source.document_title);
  if (explicitTitle) return explicitTitle;

  const title = cleanText(source.title);
  if (title) return title;

  return getSourceFileName(source) || fallback;
}

export function getSourceSecondaryFileName(source: SourceTitleFields): string | undefined {
  const fileName = getSourceFileName(source);
  if (!fileName) return undefined;

  return fileName === getSourceDocumentTitle(source) ? undefined : fileName;
}
